import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORTS } from '../../constant';
import { getToken } from '../../Utils/authUtils';

interface SendReminderPayload {
  reportId: string;
}

export const sendReminder = createAsyncThunk(
  'reports/sendReminder',
  async (payload: SendReminderPayload, { rejectWithValue }) => {
    try {
      const token = getToken();
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      };
      const res = await fetch(REPORTS.SEND_REMINDER, requestOptions);

      if (!res.ok) {
        const errorData = await res.json();
        return rejectWithValue(errorData.msg || 'Failed to send reminder');
      }

      const data = await res.json();
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to send reminder');
    }
  }
);
